jQuery(document).ready(function($){
    var tense_templates = {
        'full': wp.template('variation-image-full'),
        'thumb': wp.template('variation-image-thumb'),
    }

    $('body').on('click', '.quantity__minus', function(event) {
        event.preventDefault();

        var sel = $(this).data('quantity');
        var $qty_el = $('#' + sel);

        if ($qty_el.length) {
            var cur_qty = parseInt($qty_el.val());
            var step = $qty_el.attr('step');
            step = step == undefined ? 1 : parseInt(step);
            var min_qty = $qty_el.attr('min');
            min_qty = min_qty == undefined ? 1 : parseInt(min_qty);
            var new_qty = Math.max(min_qty, cur_qty - step);

            $qty_el.val(new_qty);
            $qty_el.trigger('change');
        }
    });

    $('body').on('click', '.quantity__plus', function(event) {
        event.preventDefault();

        var sel = $(this).data('quantity');
        var $qty_el = $('#' + sel);

        if ($qty_el.length) {
            var cur_qty = parseInt($qty_el.val());
            var step = $qty_el.attr('step');
            step = step == undefined ? 1 : parseInt(step);
            var new_qty = cur_qty + step;
            var max_qty = $qty_el.attr('max');

            if (max_qty) {
                new_qty = Math.min(new_qty, max_qty);
            }

            $qty_el.val(new_qty);
            $qty_el.trigger('change');
        }
    });

    $('body').on('change', '.quantity .qty', function(event) {
        var $parent = $(this).closest('[data-quantity-parent]');

        if ($parent.length) {
            var $btn = $parent.find('.button[data-quantity]');

            if ($btn.length) {
                $btn.attr('data-quantity', $(this).val());
                var href = $btn.attr('href');
                var regex = /quantity=\d+/;
                href = href.replace(regex, 'quantity=' + $(this).val());
                $btn.attr('href', href);
            }
        }
    });

    $('form.checkout').on('click', '.wc_payment_method .input-radio', function() {
        $('form.checkout .wc_payment_method').each(function () {
            var has_checked = $(this).find(".input-radio:checked").length;

            if (has_checked) {
                $(this).addClass("active");
            } else {
                $(this).removeClass("active");
            }
        });
    });

    $('body').on('wc_cart_button_updated', function(event, $button) {
        // $button.text(tense_vars.added_to_cart_caption);
    });

    $('body').on('adding_to_cart', function(event, $button, data) {
        var $parent = $button.closest('.product');

        if ($parent.length) {
            var $el = $parent.find('[data-modal-html]');

            if ($el.length) {
                $('.product-added-modal__info').html($el.html());
                $('.product-added-modal__info [data-modal-quantity]').text(data.quantity);
            }
        }
    });

    $('body').on('added_to_cart', function(event) {
        $('#product-added-modal').foundation('open');
    });

    $(document).on( 'found_variation', function( event, variation ) {
        if (variation.image_id == undefined || !variation.image_id) {
            return;
        }

        var sliders = ['.product__slider--main', '.product__slider--nav'];


        sliders.forEach(function(selector) {
            var slide_selector = selector + ' .slide[data-image-id="' + variation.image_id + '"]';
            var $slides = $(slide_selector);

            if ($slides.length) {
                var slide_index = $slides.eq(0).data('slick-index');
                $(selector).slick('slickGoTo', parseInt(slide_index));

                // workaround for slick bug
                $(selector).find('.slide').removeClass("slick-current");
                slide_selector = selector + ' .slide[data-slick-index="' + slide_index + '"]';
                $(slide_selector).addClass("slick-current");
            } else {
                var variations = $('.variations_form').data('product_variations');
                var variation_data = $.grep(variations, function(val, index) {
                    return val.variation_id == variation.variation_id;
                });

                var variation_template;
                if (selector.endsWith('--nav')) {
                    variation_template = tense_templates.thumb;
                } else {
                    variation_template = tense_templates.full;
                }

                if (!variation_data) {
                    return;
                }

                var variation_html = variation_template(variation_data[0]);

                var slider_opts = {
                    '.product__slider--main': {
                        dots: false,
                        speed: 1000,
                        infinite: true,
                        autoplay: false,
                        cssEase: 'ease-out',
                        arrows: false,
                        fade: true,
                        responsive: [
                            {
                                breakpoint: 640,
                                settings: {
                                    slidesToShow: 1,
                                    slidesToScroll: 1,
                                    arrows: true,
                                    appendArrows: '.product__gallery__arrows',
                                    prevArrow: '<button type="button" class="slick-prev"><i class="icon-arrow-left"></i></button>',
                                    nextArrow: '<button type="button" class="slick-next"><i class="icon-arrow-right"></i></button>',
                                    fade: false,
                                }
                            },
                        ],
                    },
                    '.product__slider--nav': {
                        dots: false,
                        speed: 1000,
                        infinite: true,
                        autoplay: false,
                        cssEase: 'ease-out',
                        arrows: false,
                        fade: false,
                        slidesToShow: 4,
                        slidesToScroll: 1,
                        centerMode: false,
                        focusOnSelect: true,
                        asNavFor: '.product__slider--main',
                        responsive: [
                            {
                                breakpoint: 1280,
                                settings: {
                                    slidesToShow: 3,
                                }
                            },
                            {
                                breakpoint: 1024,
                                settings: {
                                    slidesToShow: 2,
                                }
                            },
                            {
                                breakpoint: 800,
                                settings: {
                                    slidesToShow: 3,
                                }
                            },
                            {
                                breakpoint: 640,
                                settings: {
                                    slidesToShow: 1,
                                }
                            }
                        ],
                    },
                };

                var options = slider_opts[selector];
                $(selector).slick("unslick").html(variation_html).slick(options);

                jQuery(selector + ' a[rel="fancybox"]').fancybox({
                    'cyclic': false,
                    'autoScale': true,
                    'padding': 10,
                    'opacity': true,
                    'speedIn': 500,
                    'speedOut': 500,
                    'changeSpeed': 300,
                    'overlayShow': true,
                    'overlayOpacity': "0.3",
                    'overlayColor': "#666666",
                    'titleShow': true,
                    'titlePosition': 'inside',
                    'enableEscapeButton': true,
                    'showCloseButton': true,
                    'showNavArrows': true,
                    'hideOnOverlayClick': true,
                    'hideOnContentClick': false,
                    'width': 560,
                    'height': 340,
                    'transitionIn': "fade",
                    'transitionOut': "fade",
                    'centerOnScroll': true
                });
            }
        });
    });

    $( document.body ).on( 'updated_cart_totals', function(){
        if ( $( '.woocommerce-gifts' ).length ) {
            $( '.woocommerce-gifts__item' ).each(function( ) {
                $( '.dgfw-add-gift-button, .dgfw-select-gift-button' ).prop( 'disabled', false);
            });
        }
    });


    $( window ).on( "load", function() {
        if ( $( '.woocommerce-gifts' ).length ) {
            $( '.woocommerce-gifts__item' ).each(function( ) {
                $( '.dgfw-add-gift-button, .dgfw-select-gift-button' ).prop( 'disabled', false);
            });
        }
    });

    $(document).on( 'found_variation', function( event, variation ) {
        $('.product__prices.price').html(variation.price_html);
    });

    $('body').on('DOMSubtreeModified', '.shape-square', function() {
        var width = $(this).width();
        $(this).height(width);
    });

    $(".woocommerce-ordering").on("change", "select.per_page", function() {
        $(this).closest("form").submit();
    });

    setInterval(tense_countdown, 1000);

    function tense_pad_num(num, size) {
        var s = num+"";
        while (s.length < size) s = "0" + s;
        return s;
    }

    function tense_countdown() {
        $('[data-sale-end]').each(function() {
            var $parent = $(this);
            var date = new Date();
            var now = date.getTime() - (date.getTimezoneOffset() * 60000);
            var sale_end = parseInt($(this).data('sale-end')) * 1000;

            if (sale_end < now) {
                $(this).addClass('expired');
                return;
            }

            var delta = parseInt((sale_end - now) / 1000);
            var days = parseInt(delta / (60 * 60 * 24));
            var hours = parseInt(delta % (60 * 60 * 24) / (60 * 60));
            var minutes = parseInt(delta % (60 * 60) / 60);
            var seconds = delta % 60;

            var segments = {};
            var captions = {};

            var caption_handlers = {
                'days': function(n) {
                    return ((n > 1) || n == 0)  ? 'dni' : 'dzień';
                },
                'hours': function(n) {
                    if (n == 1) {
                        return "godzina";
                    } else if ((n % 10 >= 2) && (n % 10 <= 4) & ((n % 100 < 10) || (n % 100 >= 20))) {
                        return "godziny";
                    } else {
                        return "godzin";
                    }
                },
                'minutes': function(n) {
                    if (n == 1) {
                        return "minuta";
                    } else if ((n % 10 >= 2) && (n % 10 <= 4) & ((n % 100 < 10) || (n % 100 >= 20))) {
                        return "minuty";
                    } else {
                        return "minut";
                    }
                },
                'seconds': function(n) {
                    if (n == 1) {
                        return "sekunda";
                    } else if ((n % 10 >= 2) && (n % 10 <= 4) & ((n % 100 < 10) || (n % 100 >= 20))) {
                        return "sekundy";
                    } else {
                        return "sekund";
                    }
                },
            };

            $.each(['days', 'hours', 'minutes', 'seconds'], function(index, value) {
                segments[value] = $parent.find('[data-sale-' + value + ']');
                captions[value] = $parent.find('[data-sale-' + value + '-caption]');
            });

            segments.days.html(days);
            segments.hours.html(tense_pad_num(hours, 2));
            segments.minutes.html(tense_pad_num(minutes, 2));
            segments.seconds.html(tense_pad_num(seconds, 2));

            captions.days.html(caption_handlers.days(days));
            captions.hours.html(caption_handlers.hours(hours));
            captions.minutes.html(caption_handlers.minutes(minutes));
            captions.seconds.html(caption_handlers.seconds(seconds));

            if (days < 1) {
                $(this).addClass('urgent');
            } else {
                $(this).removeClass('urgent');
            }
        });
    }

    $('.products form.product__buttons .add_to_cart_button').click(function(event) {
        var form = $(this).closest('form').get(0);

        if (!form.checkValidity()) {
            form.reportValidity();
            event.preventDefault();
            return false;
        }
    });

    $('#billing_invoice_person').change(function() {
        if ($(this).prop('checked')) {
            $('#order_invoice').prop('checked', false);
        }
    });

    $('#order_invoice').change(function() {
        if ($(this).prop('checked')) {
            $('#billing_invoice_person').prop('checked', false);
        }
    });

});
